"use client"

import { useEffect } from "react"
import { useRouter } from "next/navigation"
import { Grid } from "react-loader-spinner"

import { useAppSelector } from "@/lib/store"

export function HomeRedirect() {
  const router = useRouter()
  const bootstrap = useAppSelector((s) => s.sessionBootstrap.data)

  useEffect(() => {
    if (!bootstrap) return
    const isAdmin = Boolean(bootstrap.user?.isAdmin)
    router.replace(isAdmin ? "/admin/dashboard" : "/contacts")
  }, [bootstrap, router])

  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-100 p-8">
      <Grid visible height="40" width="40" color="#7dd3fc" ariaLabel="loading" radius="12.5" />
    </main>
  )
}
